import type { agents as en } from "../en/agents";
import type { Messages } from "../types";

export const agents: Messages<typeof en> = {
  title: "الوكلاء",
  subtitle: "شخصيات ذكية ترد على التعليقات والرسائل بالطريقة التي تريدها: صوتها، وما تعرفه، وأين ترد، وكم ترد.",
  newAgent: "وكيل جديد",
  back: "كل الوكلاء",
  empty: { title: "لا يوجد وكلاء بعد", hint: "أنشئ وكيلك الأول: اختر له اسماً ونبرة وتعليمات، وجرّبه في ساحة التجربة، ثم عيّنه لحساب." },
  list: {
    assignments: "التعيينات: {{n}}",
    notAssigned: "غير معيّن بعد",
    repliesMonth: "{{n}} رداً هذا الشهر",
    pending: "{{n}} مسودات بانتظار الموافقة",
    edit: "فتح",
    version: "إصدار {{n}}",
  },
  status: { active: "فعّال", paused: "متوقف" },
  mode: {
    draft_for_approval: "مسودة للموافقة",
    auto_send: "إرسال تلقائي",
    draftHint: "كل رد ينتظر في الموافقات حتى يوافق عليه أحد أعضاء الفريق.",
    autoHint: "تُرسل الردود فوراً ضمن الحدود وساعات العمل.",
    autoWarning: "الإرسال التلقائي ينشر الردود علناً دون مراجعة. جرّب الوكيل في ساحة التجربة أولاً وأبقِ الحدود منخفضة.",
  },
  tabs: { configure: "الإعداد", playground: "ساحة التجربة", assignments: "أين يرد", usage: "الاستخدام والنشاط" },
  editor: {
    newTitle: "وكيل جديد",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    create: "إنشاء الوكيل",
    unsaved: "تغييرات غير محفوظة",
    saved: "حُفظ كإصدار {{n}}",
    created: "تم إنشاء الوكيل",
    conflict: "عدّل شخص آخر هذا الوكيل. أعد التحميل لرؤية أحدث إصدار.",
    failed: "تعذّر حفظ الوكيل",
    delete: "حذف الوكيل",
    deleteConfirm: "حذف {{name}}؟ تُزال تعييناته الافتراضية، وتعود المحادثات المعيّنة له إلى الإعداد الافتراضي. يبقى السجل.",
    deleted: "تم حذف الوكيل",
    versions: "الإصدارات",
    note: "ما الذي تغيّر (اختياري)",
    notePlaceholder: "مثلاً: نبرة أودّ، معلومات توصيل جديدة",
    required: "أعطِ الوكيل اسماً",
    readOnly: "المشرفون فقط يعدّلون الوكلاء. يمكنك تجربته في ساحة التجربة.",
    notFound: "هذا الوكيل لم يعد موجوداً.",
  },
  sections: {
    identity: "الهوية",
    identityHint: "كيف يظهر الوكيل لفريقك (العملاء لا يرون الاسم).",
    persona: "الشخصية والنبرة",
    personaHint: "من يتكلم؟ شخصية قصيرة ونبرة تشكّلان كل رد.",
    instructions: "التعليمات",
    instructionsHint: "ماذا يفعل الوكيل، وماذا يعرف، وكيف يتصرف. الكلمات البسيطة أفضل.",
    rules: "دائماً / أبداً",
    language: "اللغة",
    surfaces: "أسلوب الرد حسب المكان",
    surfacesHint: "الردود العامة يراها الجميع؛ الردود الخاصة والرسائل تتسع لتفاصيل أكثر.",
    model: "النموذج والإبداع",
    knowledge: "المعرفة",
    knowledgeHint: "يبحث الوكيل في معرفتك قبل الرد ويستخدم فقط الحقائق التي يجدها.",
    handoff: "التحويل إلى شخص",
    handoffHint: "عند تحقق أيٍّ من هذه، لا يرد الوكيل: يذهب العنصر إلى فريقك.",
    hours: "ساعات العمل",
    limits: "الحدود",
    limitsHint: "الحدود تُبقي التكلفة والمفاجآت منخفضة. الردود فوق الحد تُتخطّى مع السبب في سجل النشاط.",
    mode: "طريقة الإرسال",
  },
  fields: {
    name: "الاسم",
    namePlaceholder: "مثلاً: وكيل المبيعات",
    emoji: "رمز تعبيري",
    pickEmoji: "اختر رمزاً تعبيرياً",
    description: "الوصف",
    descriptionPlaceholder: "ما مهمة هذا الوكيل؟",
    status: "الحالة",
    persona: "الشخصية",
    personaPlaceholder: "مثلاً: لينا، مساعدة المبيعات اللطيفة التي تعرف كل منتج.",
    tone: "النبرة",
    instructions: "التعليمات (موجّه النظام)",
    instructionsPlaceholder: "أجب عن أسئلة منتجاتنا ومقاساتها وأسعارها والتوصيل…",
    insertSnippet: "أدرج مثالاً",
    dos: "دائماً",
    dosPlaceholder: "اكتب واضغط Enter، مثلاً: ادعُ للمراسلة الخاصة للمقاسات",
    donts: "أبداً",
    dontsPlaceholder: "مثلاً: لا تعِد بخصومات",
    remove: "إزالة",
    examples: "أمثلة ردود",
    examplesHint: "يقلّد الوكيل أسلوبها، لا معلوماتها.",
    exampleMessage: "يقول العميل",
    exampleReply: "يرد الوكيل",
    addExample: "إضافة مثال",
    language: "لغة الرد",
    enabled: "يرد هنا",
    maxLength: "الطول الأقصى",
    chars: "{{n}} حرفاً",
    style: "ملاحظات الأسلوب",
    stylePlaceholder: "مثلاً: جملة واحدة، ادعُ للخاص لمعرفة الأسعار",
    emojiLevel: "الرموز التعبيرية",
    model: "النموذج",
    temperature: "الإبداع",
    temperatureHint: "أقل = ثابت وحرفي؛ أعلى = صياغة متنوعة.",
    datasets: "البحث في",
    maxSnippets: "مقتطفات لكل رد",
    minScore: "أدنى تطابق",
    uploadDocs: "إضافة مستندات العلامة التجارية / الأسئلة الشائعة",
    keywords: "كلمات مفتاحية",
    keywordsPlaceholder: "مثلاً: استرجاع، محامي، refund",
    intents: "النوايا",
    categories: "فئاتك الذكية",
    noCategories: "لا توجد فئات ذكية بعد. أنشئها من الإعدادات ← الوسوم.",
    negative: "الرسائل السلبية",
    whenUnsure: "عندما لا يكون الوكيل متأكداً",
    assignTo: "إسناد إلى",
    nobody: "لا أحد",
    notify: "إشعار المشرفين",
    hoursEnabled: "الرد خلال ساعات العمل فقط",
    timezone: "المنطقة الزمنية",
    outside: "خارج ساعات العمل",
    outsideSkip: "لا ترد",
    outsideDraft: "مسودة للموافقة",
    from: "من",
    to: "إلى",
    closed: "مغلق",
    addWindow: "إضافة ساعات",
    perHour: "في الساعة",
    perDay: "في اليوم",
    perConversation: "لكل محادثة في اليوم",
    budgetShare: "حصة من ميزانية الذكاء الشهرية",
    noLimit: "بلا حد",
    percent: "{{n}}%",
  },
  tones: {
    friendly: "ودود",
    professional: "مهني",
    playful: "مرح",
    luxury: "فاخر",
    empathetic: "متعاطف",
    concise: "مختصر",
    custom: "مخصص",
  },
  tonePreviews: {
    friendly: "«أهلاً سارة! سعيدين إنها عجبتك 🌸 مقاس 60×90 بـ 55 دينار.»",
    professional: "«شكراً لاهتمامك. سعر لوحة 60×90 سم هو 55 ديناراً.»",
    playful: "«ذوقك حلو! 😍 الـ 60×90 إلك بـ 55 دينار.»",
    luxury: "«اختيار رائع. نسخة 60×90 سم بـ 55 ديناراً.»",
    empathetic: "«نعتذر عن التأخير يا سارة. طلبك يُشحن غداً.»",
    concise: "«60×90 سم: 55 ديناراً. توصيل مجاني داخل عمّان.»",
    custom: "صِف الصوت في الشخصية.",
  },
  snippets: {
    scope: "أجب فقط عن أسئلة منتجاتنا وطلباتنا والتوصيل. لأي أمر آخر قل بلطف إن أحد أعضاء الفريق سيرد.",
    prices: "استخدم الأسعار الموجودة في المعرفة. إن لم يوجد السعر فقل إننا سنرسله على الخاص.",
    dm: "للمقاسات والطلبات الخاصة والتفاصيل الشخصية، ادعُ العميل لمراسلتنا على الخاص.",
    complaints: "إذا كان العميل منزعجاً، اعتذر مرة واحدة، واذكر الخطوة التالية، وحوّل إلى شخص.",
  },
  languages: {
    auto: "نفس لغة العميل",
    ar: "العربية",
    "ar-gulf": "العربية (الخليجية)",
    "ar-levant": "العربية (الشامية)",
    "ar-egypt": "العربية (المصرية)",
    "ar-maghreb": "العربية (المغاربية)",
    "ar-msa": "العربية (الفصحى)",
    en: "الإنجليزية",
  },
  surfaces: { comment_public: "رد علني على تعليق", comment_private: "رد خاص", dm: "الرسائل المباشرة" },
  emoji: { none: "بدون", few: "قليلة", many: "كثيرة" },
  models: {
    "malfak-smart": "ذكي",
    "malfak-smartHint": "أفضل الإجابات، أبطأ وأعلى تكلفة قليلاً.",
    "malfak-fast": "سريع",
    "malfak-fastHint": "سريع ورخيص، مناسب للردود القصيرة.",
  },
  datasets: {
    brand: "مستندات العلامة التجارية والأسئلة الشائعة",
    brandHint: "المستندات التي ترفعها (الأسعار، السياسات، الأسئلة الشائعة).",
    content: "التعليقات والرسائل السابقة",
    contentHint: "كيف ردّ فريقك من قبل.",
  },
  playground: {
    title: "ساحة التجربة",
    hint: "جرّب الوكيل بالإعدادات التي تعدّلها، محفوظة أو لا.",
    nothingSent: "لا يُرسل شيء: هذه معاينة فقط.",
    samples: "جرّب رسالة حقيقية",
    noSamples: "لا توجد رسائل حديثة",
    surface: "الرد كـ",
    message: "رسالة العميل",
    messagePlaceholder: "اكتب ما قد يقوله العميل…",
    send: "جرّب",
    trying: "يفكّر…",
    reset: "مسح المحادثة",
    you: "العميل",
    agent: "الوكيل",
    decision: { reply: "سيرد", handoff: "يحوّل إلى شخص", skip: "لن يرد" },
    knowledge: "المعرفة التي وجدها",
    noKnowledge: "لم تتطابق أي معرفة مع هذه الرسالة.",
    knowledgeOff: "البحث في المعرفة غير متاح هنا، لذا لم تُستخدم مقتطفات.",
    score: "تطابق {{n}}%",
    violations: "الضوابط",
    violation: {
      too_long: "طويل جداً: تم اختصاره",
      url_not_allowed: "رابط غير مسموح",
      foreign_mention: "يذكر حساباً آخر",
      phone_number: "رقم هاتف",
      email: "بريد إلكتروني",
      language_mismatch: "لغة مختلفة",
      empty: "فارغ",
    },
    tokens: "{{n}} رمزاً",
    cost: "{{n}}$",
    duration: "{{n}} مللي ثانية",
    prompt: "ما يراه النموذج",
    failed: "تعذّر تشغيل ساحة التجربة",
  },
  reasons: {
    agent_paused: "الوكيل متوقف",
    surface_disabled: "الوكيل لا يرد هنا",
    outside_hours: "خارج ساعات العمل",
    limit_hour: "تم بلوغ الحد بالساعة",
    limit_day: "تم بلوغ الحد اليومي",
    limit_conversation: "تم بلوغ حد هذه المحادثة",
    budget_share: "استهلك الوكيل حصته من ميزانية الذكاء",
    plan_limit: "استُهلكت ردود الوكلاء في خطتك",
    ai_disabled: "الذكاء الاصطناعي متوقف من المنصة",
    ai_budget: "استُهلكت ميزانية الذكاء لهذا الشهر",
    ai_unavailable: "الذكاء الاصطناعي غير متاح",
    messaging_window_closed: "نافذة المراسلة (24 ساعة) مغلقة",
    private_reply_window: "الردود الخاصة مسموحة خلال 7 أيام فقط",
    already_replied: "تم الرد مسبقاً",
    handoff_keyword: "كلمة تحويل",
    handoff_intent: "النية تذهب إلى شخص",
    handoff_category: "الفئة تذهب إلى شخص",
    handoff_negative: "الرسالة السلبية تذهب إلى شخص",
    handoff_model: "الوكيل لم يكن متأكداً",
    guardrails: "خالفت المسودة ضوابط الرد",
    conversation_off: "الذكاء متوقف لهذه المحادثة",
    no_agent: "لا يوجد وكيل معيّن",
    not_applicable: "لا ينطبق",
  },
  runStatus: { drafted: "مسودة", sent: "أُرسل", skipped: "تم التخطي", handoff: "حُوّل", failed: "فشل" },
  triggers: { auto: "تلقائي", rule: "قاعدة", manual: "صياغة بالوكيل", playground: "ساحة التجربة", batch: "دفعة" },
  sources: {
    rule: "من القاعدة {{label}}",
    conversation: "معيّن لهذه المحادثة",
    post: "من الإعداد الافتراضي للمنشور",
    account: "من الإعداد الافتراضي للحساب",
    channel: "من الإعداد الافتراضي لـ {{label}}",
    any: "افتراضي",
  },
  assignments: {
    title: "افتراضي لـ",
    hint: "التعليقات والرسائل هنا تستخدم هذا الوكيل ما لم تحدد قاعدة أو محادثة غير ذلك.",
    order: "الترتيب: القاعدة ← المحادثة ← المنشور ← الحساب ← القناة.",
    add: "إضافة افتراضي",
    targetType: "افتراضي لـ",
    types: { channel: "كل حسابات قناة", account: "حساب", post: "منشور" },
    target: "أيّ",
    surface: "لـ",
    surfaceOptions: { all: "التعليقات والرسائل", comments: "التعليقات", dms: "الرسائل" },
    remove: "إزالة",
    removed: "أُزيل الافتراضي",
    added: "أصبح الافتراضي لـ {{label}}",
    empty: "ليس افتراضياً في أي مكان بعد.",
    conversations: "المحادثات المعيّنة",
    noConversations: "لا توجد محادثات معيّنة لهذا الوكيل.",
    rules: "القواعد التي تستخدم هذا الوكيل",
    noRules: "لا توجد قاعدة تستخدم هذا الوكيل بعد.",
    pickAccount: "اختر حساباً",
    pickPost: "اختر منشوراً",
    instagram: "إنستغرام",
  },
  usage: {
    today: "ردود اليوم",
    month: "ردود هذا الشهر",
    sent: "أُرسل هذا الشهر",
    pending: "مسودات بالانتظار",
    skipped: "تم التخطي هذا الشهر",
    handoffs: "حُوّل هذا الشهر",
    cost: "تكلفة الذكاء هذا الشهر",
    tokens: "{{n}} رمزاً",
    budget: "حصة الميزانية",
    noBudget: "بلا حد ميزانية خاص",
    of: "من {{n}}",
    limitHour: "الحد بالساعة",
    limitDay: "الحد اليومي",
  },
  activity: {
    title: "النشاط",
    empty: "لا يوجد نشاط بعد. عيّن الوكيل أو صِغ رداً لتراه هنا.",
    filter: "الحالة",
    all: "الكل",
    openApproval: "فتح الموافقة",
    openItem: "فتح",
    more: "تحميل المزيد",
    version: "إصدار {{n}}",
  },
  versions: {
    title: "الإصدارات",
    hint: "كل حفظ إصدار. تسجّل التشغيلات والردود الإصدار الذي كتبها.",
    current: "الحالي",
    restore: "استعادة",
    restored: "استُعيد الإصدار {{n}} (حُفظ كإصدار {{m}})",
    restoreConfirm: "استعادة الإصدار {{n}}؟ يُحفظ كإصدار جديد؛ لا يضيع شيء.",
  },
  picker: {
    label: "الوكيل المعيّن",
    off: "الذكاء متوقف",
    offHint: "لا ردود ذكية في هذه المحادثة: أنت ترد يدوياً.",
    inherit: "استخدم الافتراضي",
    handledBy: "يتولى هذه المحادثة: {{agent}} ({{source}})",
    nobody: "لا يوجد وكيل يتولى هذه المحادثة.",
    updated: "تم تحديث الوكيل",
    turnedOff: "تم إيقاف الذكاء لهذه المحادثة",
    failed: "تعذّر تغيير الوكيل",
    manage: "إدارة الوكلاء",
  },
  draft: {
    button: "صياغة بالوكيل",
    pick: "صياغة بـ",
    drafting: "جارٍ الصياغة…",
    done: "صاغ {{agent}} رداً: ينتظر في الموافقات.",
    skipped: "لم يصغ {{agent}} رداً: {{reason}}",
    open: "فتح الموافقة",
    noAgent: "اختر وكيلاً أولاً",
    failed: "تعذّرت صياغة رد",
  },
  comment: {
    title: "الوكيل الذكي",
    handledBy: "يتولاه {{agent}} ({{source}})",
    none: "لا يوجد وكيل يرد على هذا التعليق. عيّن افتراضياً للحساب أو للمنشور.",
  },
  approval: { draftedBy: "صاغه {{agent}} إصدار {{version}}" },
};
